<div class="main-wrapper mx-auto">
    <main class="main d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-10 col-lg-8 mx-md-auto p-sm-0 mx-lg-auto">
                    <div class="card mx-4">
                        <div class="card-header">
							<div class="row">
								<div class="col-8">
									<h4 class="">Reset Password</h4>
								</div>
								<div class="col-4 ">
									<button (click)="back()" class="btn btn-light text-dark float-right"><i
											class="fa fa-reply"></i>&nbsp;<b>Back</b></button>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div *ngIf="(!showTokenExpiredDiv && !showSuccessDiv)">
                                <form [formGroup]="resetPasswordForm">
                                    <div class="form-group">
                                        <label for="exampleInputPassword1" class="mb-0"> New Password</label><span
                                            class="required">*</span>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="icon-lock"></i></span>
                                            </div>
                                            <input [type]="fieldPasswordType ? 'text' : 'password'" class="form-control"
                                                placeholder="Password" formControlName="password">
                                            <div class="input-group-append" (click)="toggleFieldPasswordType()">
                                                <span class="input-group-text">
                                                    <i class="fa" [ngClass]="{
                                                          'fa-eye-slash': fieldPasswordType,
                                                          'fa-eye': !fieldPasswordType}">
                                                    </i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="error-msg-area">
                                            <div
                                                *ngIf="resetPasswordForm.controls['password'].errors && (!resetPasswordForm.controls['password'].pristine || isresettPasswordFormSubmitted)">
                                                <div [hidden]="!resetPasswordForm.controls['password']?.errors.required">Please Enter New
                                                    Password</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="exampleInputPassword1" class="mb-0">Confirm Password</label><span
                                            class="required">*</span>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="icon-lock"></i></span>
                                            </div>
                                            <input [type]="fieldConfirmPasswordType ? 'text' : 'password'" class="form-control"
                                                placeholder="Confirm Password" formControlName="confirmPassword">
                                            <div class="input-group-append" (click)="toggleFieldConfirmPasswordType()">
                                                <span class="input-group-text">
                                                    <i class="fa" [ngClass]="{
                                                        'fa-eye-slash': fieldConfirmPasswordType,
                                                        'fa-eye': !fieldConfirmPasswordType}">
                                                    </i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="error-msg-area">
                                            <div
                                                *ngIf="resetPasswordForm.controls['confirmPassword'].errors && (!resetPasswordForm.controls['confirmPassword'].pristine || isresettPasswordFormSubmitted)">
                                                <div [hidden]="!resetPasswordForm.controls['confirmPassword']?.errors.required">Please
                                                    Enter Confirm Password
                                                </div>
                                                <div
                                                    [hidden]="!resetPasswordForm.controls['confirmPassword']?.errors.passwordMisMatches">
                                                    Confirm Password
                                                    has to match the new Password</div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="card-footer">
                                <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="spinner">Submit</button>
                            </div>
                        </div>
                        
                        <!-- If Token Expired or Invalid Div-->
				<div *ngIf="showTokenExpiredDiv" class="text-center">
					<span class="display-4 "
						[ngClass]="TokenExpired==true?'fa fa-hourglass-end text-muted':'fa fa-exclamation-triangle text-danger'"></span>
					<h5>Your Link to reset your password is <span *ngIf="!TokenExpired">Invalid.</span> <span
							*ngIf="TokenExpired">Expired.</span></h5>
					<p class="text-muted" *ngIf="TokenExpired">
						Please Note that the link to reset password is valid only for 60 minutes.
					</p>
					Click here to&nbsp;
					<a class="text-underlined" routerLink="/auth/forgot-password">Try again</a>
				</div>
				<!-- If Token Expired or Invalid Div Ends-->
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
<div class="loader" *ngIf="spinner"></div>